import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { useCatalogData } from './CatalogDataContext';
import { fallbackImage } from './catalogData';
import './catalog-detail.css';

const BoardDetail = ({ history, location, match }) => {
  const { boardId } = match.params;
  const { boards } = useCatalogData();

  const board = useMemo(() => {
    if (location.state && location.state.board) {
      return location.state.board;
    }

    return boards.find((item) => item.id === boardId);
  }, [boardId, boards, location.state]);

  if (!board) {
    return (
      <section className="catalog-detail catalog-detail--missing">
        <div className="catalog-detail__card">
          <h1>We couldn&apos;t find that board</h1>
          <p>The board you&apos;re looking for is unavailable. Head back to templates to explore other boards.</p>
          <div className="catalog-detail__actions">
            <button type="button" onClick={() => history.push('/templates')}>
              Back to templates
            </button>
            <Link to="/templates">Browse boards</Link>
          </div>
        </div>
      </section>
    );
  }

  const thumbnails = board.thumbnails && board.thumbnails.length > 0 ? board.thumbnails : [fallbackImage];

  return (
    <section className="catalog-detail" aria-labelledby="board-heading">
      <div className="catalog-detail__media catalog-detail__media--board" aria-hidden="true">
        <div className="catalog-detail__media-grid">
          {thumbnails.map((thumbnail, index) => (
            <img
              key={`${board.id}-thumb-${index}`}
              src={thumbnail || fallbackImage}
              alt=""
              onError={(event) => {
                event.currentTarget.src = fallbackImage;
              }}
            />
          ))}
        </div>
      </div>
      <div className="catalog-detail__body">
        <p className="catalog-detail__eyebrow">Inspiration board</p>
        <h1 id="board-heading">{board.title}</h1>
        <p className="catalog-detail__description">{board.theme}</p>
        <div className="catalog-detail__actions">
          <button type="button" onClick={() => history.push('/templates')}>
            Back to inspiration boards
          </button>
          <a href="/templates" className="catalog-detail__link">
            Add to workspace
          </a>
        </div>
      </div>
    </section>
  );
};

export default BoardDetail;
